module.exports = __webpack_public_path__ + "img/sc-2.71f1adfb.png";